import * as actionTypes from './actionTypes';
import type { InboundSMS } from './types';

/*------------------------------------------------------------------------------------------------*/
/* InboundSMS Fetch Actions                                                                             */
/*------------------------------------------------------------------------------------------------*/
/**
 * fetchInboundSMSRequest
 * Fetch inboundSMS request action.
 */
export const fetchInboundSMSRequest = () => ({
  type: actionTypes.FETCH_INBOUND_SMS_REQUEST,
});

/**
 * fetchInboundSMSError
 * Fetch inboundSMS request error action.
 */
export const fetchInboundSMSError = (error: string) => ({
  type: actionTypes.FETCH_INBOUND_SMS_ERROR,
  error,
});

/**
 * fetchInboundSMSResponse
 * Fetch inboundSMS response action.
 */
export const fetchInboundSMSResponse = (response: InboundSMS[]) => ({
  type: actionTypes.FETCH_INBOUND_SMS_RESPONSE,
  response,
});
